export default class VideoIframeService {
    /**
     * Отправка сообщения
     * @param iframe
     * @param message
     */
    public static sendMessageToIframe(
        iframe: HTMLIFrameElement,
        message: string
    ): void {
        iframe.contentWindow?.postMessage(
            `{"event":"command","func": "${message}","args":""}`,
            '*'
        );
    }
}
